module.exports = __webpack_public_path__ + "img/candy-shard.a10cc697.svg";